import { PR_NAMES, type PrKind } from '@squats/shared';

/** "PR" next to a set, naming the records in its tooltip and for screen readers. */
export function PrBadge({ kinds }: { kinds: PrKind[] | undefined }) {
  if (!kinds?.length) return null;
  const names = kinds.map((k) => PR_NAMES[k]).join(', ');
  return (
    <span className="pill pr" title={names} aria-label={`Personal record: ${names}`}>
      PR
    </span>
  );
}
